import { routeNaming } from '../../routes';
import { Cart } from '../../pages/cart';
import { ChangePassword } from '../../pages/change-password';
import { CheckoutCoordinator } from '../../pages/checkout-coordinator';
import { ForgotPassword } from '../../pages/forgot-password';
import { InstallationCoordination } from '../../pages/installation-coordination';
import { Login } from '../../pages/login';
import { LoginValidator } from '../../pages/login-validator';
import { MyAccount } from '../../pages/my-account';
import { MyAccountMenuMobile } from '../../pages/my-account/my-account-menu-mobile';
import { MyAddresses } from '../../pages/my-account/my-addresses';
import { MyBillingData } from '../../pages/my-account/my-billing-data';
import { MyData } from '../../pages/my-account/my-data';
import { MyFavorites } from '../../pages/my-account/my-favorites';
import { MyCredit } from '../../pages/my-account/my-credit';
import { MyOrders } from '../../pages/my-account/my-orders';
import { MyPhoneNumbers } from '../../pages/my-account/my-phone-numbers';
import { PaymentMethodsAndBilling } from '../../pages/payment-methods-and-billing';
import { RecoverAccount } from '../../pages/recover-account';
import { Register } from '../../pages/register';
import { CheckoutBankSummary } from '../../pages/checkout-bank-summary';
import { BillingDetail } from '../../pages/billing-detail';

const routeConfig = [
  {
    name: routeNaming.CHECKOUT,
    component: CheckoutCoordinator,
  },
  {
    name: routeNaming.LOGIN,
    component: Login,
  },
  {
    name: routeNaming.LOGIN_VALIDATOR,
    component: LoginValidator,
  },
  {
    name: routeNaming.REGISTER,
    component: Register,
  },
  {
    name: routeNaming.FORGOT_PASSWORD,
    component: ForgotPassword,
  },
  {
    name: routeNaming.CHANGE_PASSWORD,
    component: ChangePassword,
  },
  {
    name: routeNaming.RECOVER_ACCOUNT,
    component: RecoverAccount,
  },
  {
    name: routeNaming.MY_ACCOUNT,
    component: MyAccount,
  },
  {
    name: routeNaming.MY_ACCOUNT_MENU_MOBILE,
    component: MyAccountMenuMobile,
  },
  {
    name: routeNaming.COORDINATION,
    component: InstallationCoordination,
  },
  {
    name: routeNaming.MY_DATA,
    component: MyData,
  },
  {
    name: routeNaming.MY_FAVORITES,
    component: MyFavorites,
  },
  {
    name: routeNaming.MY_CREDITS,
    component: MyCredit,
  },
  {
    name: routeNaming.MY_ORDERS,
    component: MyOrders,
  },
  {
    name: routeNaming.MY_PHONE_NUMBERS,
    component: MyPhoneNumbers,
  },
  {
    name: routeNaming.CART,
    component: Cart,
  },
  {
    name: routeNaming.MY_BILLING_DATA,
    component: MyBillingData,
  },
  {
    name: routeNaming.PAYMENT_METHODS_AND_BILLING,
    component: PaymentMethodsAndBilling,
  },
  {
    name: routeNaming.MY_ADDRESSES,
    component: MyAddresses,
  },
  {
    name: routeNaming.CHECKOUT_BANK_SUMMARY,
    component: CheckoutBankSummary,
  },
  {
    name: routeNaming.BILLING_DETAIL,
    component: BillingDetail,
  },
];

export { routeConfig };



// WEBPACK FOOTER //
// ./src/apps/checkout/routes.js